import { __assign, __rest } from "tslib";
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { menuGroupCSS } from './styles';
var MenuGroup = function (_a) {
    var maxWidth = _a.maxWidth, minWidth = _a.minWidth, minHeight = _a.minHeight, maxHeight = _a.maxHeight, testId = _a.testId, rest = __rest(_a, ["maxWidth", "minWidth", "minHeight", "maxHeight", "testId"]);
    return (jsx("div", __assign({ css: menuGroupCSS({ maxHeight: maxHeight, maxWidth: maxWidth, minHeight: minHeight, minWidth: minWidth }), "data-testid": testId }, rest)));
};
export default MenuGroup;
//# sourceMappingURL=menu-group.js.map